import { Button } from "../../../core/basic/Button";
import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { LAUNCH_STATES } from "./constants";
import ProductLaunchForm from "./ProductLaunchForm";
import { Modal } from "../../../core/basic/Modal";
import { useTranslation } from "react-i18next";

const LaunchEditModal = ({ launchData, id }) => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation(["merchandising"]);
  const isLaunched = launchData?.state?.toLowerCase() === LAUNCH_STATES.LAUNCHED.value.toLowerCase();

  return (
    <>
      <Button
        onPress={() => {
          setShowModal(!showModal);
        }}
        css={{
          marginRight: "2rem",
          _hover: {
            backgroundColor: "lightgrey",
            color: "button.primary.backgroundColor",
            boxShadow: "0 15px 20px rgb(54 58 56 / 40%)",
            transform: "translateY(-7px)",
          },
        }}
      >
        {isLaunched ? t(($) => $.merchandising["Extend Launch"]) : t(($) => $.merchandising["Edit Launch"])}
      </Button>

      <Modal
        isOpen={showModal}
        onOpenChange={(isOpen) => setShowModal(isOpen)}
        title={
          isLaunched ?
            t(($) => $.merchandising["Extend Product Launch"])
          : t(($) => $.merchandising["Update Product Launch"])
        }
        css={{
          marginTop: "2rem",
          width: isLaunched ? "60vw" : "70vw",
          padding: "xlarge",
        }}
      >
        <Row style={{ display: "flex", justifyContent: "center", overflowY: "auto" }}>
          <Col
            xs={12}
            style={{
              margin: isLaunched ? "0 35px" : "0 80px",
            }}
          >
            <ProductLaunchForm
              editForm={true}
              launchData={launchData}
              id={id}
              showModal={showModal}
              setShowModal={setShowModal}
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default LaunchEditModal;
